<main class="dialog-body">
  <div class="dialog-header">
    <div class="dialog-header-text">
      {{ isEdit ? "Edit student details" : "Add student details" }}
    </div>
    <div
      class="cross-icon"
      (click)="onCancel()"
      [class.disabled]="isProcessing"
    >
      <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <form
      id="add-student-form"
      [formGroup]="form"
      (ngSubmit)="onSubmit()"
      class="d-grid gap-14"
    >
      <div class="form-group" *ngIf="addStudent !== undefined">
        <div class="d-flex align-items-start justify-content-between">
          <div class="w-100">
            <app-multi-select
              *ngIf="addStudent == undefined || addStudent"
              placeholder="Search students.."
              [options]="studentOptions"
              [required]="true"
              [errorMessage]="'Please select at least one student'"
              formControlName="studentName"
              [hideSelectedTags]="true"
              [inlineDropdown]="true"
              (selectionChange)="onStudentSelectionChange($event)"
            >
            </app-multi-select>
          </div>

          <Button
            type="button"
            class="add-button"
            (click)="onAddNewStudent()"
            *ngIf="addStudent"
          >
            Add student
          </Button>
        </div>

        <!-- For non-teacher role: Show single select
        <app-input
          *ngIf="(addStudent == undefined || addStudent) && role !== 'teacher'"
          context="Normal"
          class="form-item"
          placeholder="Search student.."
          type="search-select"
          [control]="form.get('studentName')"
          [options]="studentOptions"
          [showAddNew]="true"
          [addNewText]="'Add student'"
          (addNewClicked)="onAddNewStudent()"
          [customErrorMessages]="customErrorMessages.studentName"
        >
        </app-input> -->

        <!-- Assigned students chips -->
        <div *ngIf="addStudent && selectedStudentIDs.length > 0" class="assigned-students-section">
          <div class="assigned-students-label">Assigned students</div>
          <div class="assigned-students-chips">
            <span *ngFor="let id of selectedStudentIDs" class="assigned-chip">
              {{ getStudentLabel(id) }}
              <button type="button" class="chip-remove-btn" (click)="removeStudentChip(id)">×</button>
            </span>
          </div>
        </div>

        <div class="d-flex justify-content-end" *ngIf="!addStudent">
          <div
            *ngIf="!addStudent"
            class="custom-option add-option"
            (click)="onAddNewStudent()"
          >
            Add existing student
          </div>
        </div>
      </div>

      <div *ngIf="!addStudent" class="d-grid gap-14">
        <div class="form-group" *ngIf="!selectedSchoolID">
          <app-input
            context="Normal"
            class="form-item"
            label="Select school"
            placeholder="Select school"
            type="select"
            [control]="form.get('schoolName')"
            [options]="schoolOptions"
            [showAddNew]="role !== 'teacher'"
            [required]="true"
            [addNewText]="'Add new school'"
            (addNewClicked)="onAddNewSchool()"
            [customErrorMessages]="customErrorMessages.schoolName"
            [disabled]="!addStudent && !!selectedSchoolID"
          >
          </app-input>
        </div>

        <div class="grid-container">
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="First name"
              placeholder="Enter your first name"
              type="text"
              [control]="form.get('firstName')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.firstName"
            >
            </app-input>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Last name"
              placeholder="Enter your last name"
              type="text"
              [control]="form.get('lastName')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.lastName"
            >
            </app-input>
          </div>
        </div>

        <div class="grid-container">
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Email (School)"
              placeholder="Enter your email"
              type="text"
              [control]="form.get('schoolEmail')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.schoolEmail"
            >
            </app-input>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Email (Personal)"
              [optional]="true"
              placeholder="Enter your email"
              type="email"
              [control]="form.get('personalEmail')"
              [customErrorMessages]="customErrorMessages.personalEmail"
            >
            </app-input>
          </div>
        </div>

        <div class="grid-container">
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Date of birth"
              placeholder="Enter your date of birth"
              type="date"
              [dateType]="true"
              [control]="form.get('dob')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.dob"
            >
            </app-input>
          </div>
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Year level/Grade"
              [optional]="true"
              placeholder="Enter your year level"
              type="select"
              [required]="false"
              [control]="form.get('yearLevel')"
              [options]="yearLevelOption"
              [customErrorMessages]="customErrorMessages.yearLevel"
            >
            </app-input>
          </div>
        </div>

        <div class="grid-container">
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Parent / Guardian full name"
              placeholder="Enter your parent / guardian full name"
              type="text"
              [control]="form.get('parentName')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.parentName"
            >
            </app-input>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Parent / Guardian email"
              placeholder="Enter your parent / guardian email"
              type="text"
              [control]="form.get('parentEmail')"
              [required]="true"
              [customErrorMessages]="customErrorMessages.parentEmail"
            >
            </app-input>
          </div>
        </div>

        <div class="grid-container">
          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Gender"
              placeholder="Select Gender"
              [optional]="true"
              [required]="true"
              type="select"
              [control]="form.get('gender')"
              [options]="genderOption"
              [customErrorMessages]="customErrorMessages.gender"
            >
            </app-input>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              class="form-item"
              label="Ethnicity"
              placeholder="Enter your ethnicity"
              type="select"
              [control]="form.get('ethnicity')"
              [optional]="true"
              [required]="true"
              [options]="ethnicityOption"
              [customErrorMessages]="customErrorMessages.ethnicity"
            >
            </app-input>
          </div>
        </div>

        <div class="d-grid gap-3">
          <div class="question-grid">
            <div class="primary-text">
              1. In the past 12 months, have you (or the student) been enrolled in any construction-related course at any level (e.g., school, vocational training, or tertiary education)?
              <span style="color: red;">*</span>
            </div>
            <div>
              <app-input
                context="Normal"
                class="form-item"
                placeholder="Select"
                [required]="true"
                type="select"
                [control]="form.get('constructionCourse')"
                [options]="dataOption"
                [customErrorMessages]="customErrorMessages.constructionCourse"
              ></app-input>
            </div>
          </div>

          <div class="checkbox-grid" *ngIf="showConstructionCourseAnswers">
            <div
              *ngFor="let area of constructionPastAnswers"
              class="checkbox-wrapper"
            >
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  [value]="area.id"
                  (change)="onSelectChange($event, 1)"
                  [checked]="form.value.pastAnswers?.includes(area.id)"
                />
                <span class="checkmark"></span>
                <span class="form-label2">{{ area.courseName }}</span>
              </label>
            </div>
          </div>
          <div class="error-message-container" *ngIf="showPastAnswersError">
            <div class="error-message">Please select at least one course.</div>
          </div>

          <div class="question-grid">
            <div class="primary-text">
              2. Are you (or the student) currently enrolled in, or have you (they) previously completed, any construction-related courses?
              <span style="color: red;">*</span>
            </div>
            <div>
              <app-input
                context="Normal"
                class="form-item"
                placeholder="Select"
                [required]="true"
                type="select"
                [control]="form.get('constructionRelatedCourse')"
                [options]="dataOption"
                [customErrorMessages]="customErrorMessages.constructionRelatedCourse"
              ></app-input>
            </div>
          </div>

          <div
            class="checkbox-grid"
            *ngIf="showConstructionRelatedCourseAnswers"
          >
            <div
              *ngFor="let area of constructionCompAnswers"
              class="checkbox-wrapper"
            >
              <label class="custom-checkbox">
                <input
                  type="checkbox"
                  [value]="area.id"
                  (change)="onSelectChange($event, 2)"
                  [checked]="form.value.completedAnswers?.includes(area.id)"
                />
                <span class="checkmark"></span>
                <span class="form-label2">{{ area.courseName }}</span>
              </label>
            </div>
          </div>
          <div class="error-message-container" *ngIf="showCompAnswersError">
            <div class="error-message">Please select at least one course.</div>
          </div>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="action-buttons">
    <button
      class="dialog-button cancel-button"
      type="button"
      (click)="onCancel()"
      [disabled]="isProcessing"
    >
      Cancel
    </button>
    <button
      class="dialog-button update-button"
      type="submit"
      form="add-student-form"
      [disabled]="isProcessing"
    >
      <span *ngIf="!isProcessing">{{ isEdit ? "Update" : "Submit" }}</span>
      <span *ngIf="isProcessing" class="submit-loading">
        <span class="spinner"></span>
        {{ isEdit ? "Updating..." : "Submiting..." }}
      </span>
    </button>
  </mat-dialog-actions>
</main>
